import React from "react";
import { generatePath, Link, useNavigate, useParams } from "react-router-dom";
import { INDIVIDUAL_MANAGE_GOALS, INDIVIDUAL_SESSION_REPORT, TREATMENT_PLAN, TREATMENT_PLAN_REPORT, TREATMENT_PLAN_REPORT_PREVIEW } from "config/paths";
import GoalsTracking from "../../components/GoalsTracking/Index";

const ClientStartSession = () => {
  const navigate = useNavigate();
  const { assessmentId, clientId, clientType } = useParams();

  const submitCallback = async (response) => {
    try {
      if (response.data) {
        navigate(
          generatePath(INDIVIDUAL_SESSION_REPORT, {
            assessmentId,
            clientId,
            clientType
          })
        );
      }
    } catch (err) {
      console.erro("Error submitting step two", err);
    }
  };

  const handleClickBack = () => {
    navigate(
      generatePath(INDIVIDUAL_MANAGE_GOALS, {
        assessmentId,
        clientId,
        clientType
      })
    );
  }

  return (
    <>
      <GoalsTracking
        onSubmit={submitCallback}
        onNavigateBack={handleClickBack}
        clientType={clientType}
      />
    </>
  );
};

export default ClientStartSession;
